export default __webpack_public_path__ + "static/media/cai-design05.291efeb8.jpg";